import { motion } from "framer-motion";
import { RefreshCw, FileCheck2, CarFront, Hash, FileCog, SearchCheck, MoreHorizontal, ArrowRight } from "lucide-react";

const services = [
  { icon: RefreshCw, name: "Transferência de veículo", desc: "Transferência de propriedade com segurança e agilidade." },
  { icon: FileCheck2, name: "Licenciamento", desc: "Licenciamento anual do seu veículo sem complicação." },
  { icon: CarFront, name: "Primeiro registro", desc: "Registro de veículo zero km de forma descomplicada." },
  { icon: Hash, name: "Emplacamento", desc: "Emplacamento e placas dentro do padrão vigente." },
  { icon: FileCog, name: "Regularização de documentação", desc: "Regularização de pendências na documentação do veículo." },
  { icon: SearchCheck, name: "Vistoria", desc: "Vistoria veicular com profissionais habilitados." },
  { icon: MoreHorizontal, name: "Outros serviços", desc: "Demais serviços relacionados a veículos e documentação." },
];

export const Services = () => (
  <section id="servicos" data-testid="services-section" className="py-20 md:py-32 px-4 sm:px-6 lg:px-8 bg-[#EEF3FB]">
    <div className="max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col md:flex-row md:items-end md:justify-between gap-6"
      >
        <div>
          <p className="font-mono-brand text-xs tracking-[0.25em] uppercase text-[#2E9FDB] mb-4">Serviços</p>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-slate-900 max-w-xl">
            Documentação de veículos, do início ao fim
          </h2>
        </div>
        <p className="text-sm text-slate-600 max-w-sm leading-relaxed">
          Encaminhamos sua solicitação ao profissional mais indicado para atender à sua necessidade, no seu estado e cidade.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
        {services.map((s, i) => (
          <motion.a
            key={s.name}
            href="#solicitar"
            data-testid={`service-card-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="service-card group rounded-2xl bg-white border border-slate-200 shadow-sm p-7 flex flex-col"
          >
            <div className="w-10 h-10 rounded-lg bg-[#2E9FDB]/10 border border-[#2E9FDB]/20 flex items-center justify-center mb-5">
              <s.icon className="w-5 h-5 text-[#2E9FDB]" />
            </div>
            <h3 className="font-heading font-semibold text-base text-slate-900 mb-2">{s.name}</h3>
            <p className="text-sm text-slate-600 leading-relaxed flex-1">{s.desc}</p>
            <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-heading font-semibold uppercase tracking-wide text-[#2E9FDB] opacity-70 group-hover:opacity-100 transition-opacity">
              Solicitar <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
